import { MutationFn, UseQueryFn } from 'shared-ui';

import { FormatTyp } from './autoExport.enum';
import {
  AutoExportConfig,
  AutoExportPreviewResponse,
  AutoExportStatus,
  StartAutoExportResponse,
  StopAutoExportResponse,
  UpdateAutoExportConfigBody,
} from './autoExport.types';

export const getAutoExportConfig: UseQueryFn<void, AutoExportConfig> = () => ({
  endpoint: '/automatyzacja/config',
});

export const getAutoExportStatus: UseQueryFn<void, AutoExportStatus> = () => ({
  endpoint: '/automatyzacja/status',
});

export const getAutoExportPreview: UseQueryFn<FormatTyp, AutoExportPreviewResponse> = (formatTyp) => ({
  endpoint: `/automatyzacja/preview?formatTyp=${formatTyp}`,
});

export const updateAutoExportConfig: MutationFn<UpdateAutoExportConfigBody, AutoExportConfig> = (body) => ({
  endpoint: '/automatyzacja/config',
  method: 'PUT',
  body,
});

export const uploadKluczPrywatny: MutationFn<FormData, { success: boolean }> = (formData) => ({
  endpoint: '/automatyzacja/config/klucz',
  method: 'POST',
  body: formData,
  file: true,
});

export const startAutoExport: MutationFn<undefined, StartAutoExportResponse> = () => ({
  endpoint: '/automatyzacja/start',
  method: 'POST',
});

export const stopAutoExport: MutationFn<undefined, StopAutoExportResponse> = () => ({
  endpoint: '/automatyzacja/stop',
  method: 'POST',
});
